import {
  ballArr,
  count,
  singleDouble,
  singleDoubleCnname,
  smallBig,
  smallBigCnname,
  dragonTiger,
  fishCnname
} from "../../../../helpers/resPatterns";
import dayjs from "dayjs";

const xyrb = () => {
  const list = Vue => {
    return Vue.showMobile
      ? [
          {
            title: "时间",
            align: "center",
            render: (h, { row }) => {
              return <span>{dayjs(row.resultDate).format("HH:mm")}</span>;
            }
          },
          {
            title: "期号",
            align: "center",
            key: "issueId",
            render: (h, { row }) => {
              return (
                <span>{row.issueId.substring(row.issueId.length - 4)}</span>
              );
            }
          },
          {
            title: "号码",
            align: "center",
            width: "400",
            render: (h, { row }) => {
              var balls = ballArr(row.resultStr);
              var c = balls.reduce((a, b) => {
                return a + b;
              });
              return (
                <div class="ball num">
                  <span class="number">{balls[0]}</span>
                  <span class="number">{balls[1]}</span>
                  <span class="number">{balls[2]}</span>
                </div>
              );
            }
          }
        ]
      : [
          {
            title: "时间",
            align: "center",
            render: (h, { row }) => {
              return (
                <span>
                  {dayjs(row.resultDate).format("YYYY-MM-DD HH:mm:ss")}
                </span>
              );
            }
          },
          {
            title: "期数",
            align: "center",
            key: "issueId"
          },
          {
            title: "开奖号码",
            align: "center",
            width: "400",
            render: (h, { row }) => {
              var balls = ballArr(row.resultStr);
              var c = balls.reduce((a, b) => {
                return a + b;
              });
              return (
                <div class="ball num">
                  <span class="number">{balls[0]}</span>
                  <span class="symbol">+</span>
                  <span class="number">{balls[1]}</span>
                  <span class="symbol">+</span>
                  <span class="number">{balls[2]}</span>
                  <span class="symbol">=</span>
                  <span class="number red">{c}</span>
                </div>
              );
            }
          },
          {
            title: "总和",
            align: "center",
            render: (h, { row }) => {
              let arr = ballArr(row.resultStr);
              return (
                <div class="insideTableTd">
                  <p class="count brr">{count(arr)}</p>
                  <p class="singleDouble brr">
                    {singleDouble(count(arr)) == 0 ? (
                      <span class="blue">单</span>
                    ) : (
                      <span class="red">双</span>
                    )}
                  </p>
                  <p class="smallBig">
                    {smallBig(count(arr), 27) == 0 ? (
                      <span class="blue">小</span>
                    ) : (
                      <span class="red">大</span>
                    )}
                  </p>
                </div>
              );
            }
          }
        ];
  };
  return { list };
};

export default xyrb;



// WEBPACK FOOTER //
// ./src/pages/Trend/Jishikaijiang/columns/xyrb.js